import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/taggedTemplateLiteralLoose';
import { css } from '@emotion/css';

var _templateObject;
var filledIconStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  color: var(--yellow-500);\n"])));
var CLASSES = {
  icon: 'transform-none',
  iconEmpty: 'text-icon-placeholder',
  iconFilled: filledIconStyles
};

export { CLASSES, filledIconStyles };
//# sourceMappingURL=styles.js.map
